module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tipsPage"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "hidden-sm-down"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tips-section1.jpg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("\n        藥餌的殺滅效用\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n        了解威滅"), _c('sup', [_vm._v("®")]), _vm._v(" 藥餌如何有效針對害蟲巢穴\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tips-section1-m.jpg")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "hidden-md-up"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          藥餌的殺滅效用\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          了解威滅"), _c('sup', [_vm._v("®")]), _vm._v(" 藥餌如何有效針對害蟲巢穴\n        ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/tips-section2.jpg")
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("殺蟲藥的指引")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n        曱甴和螞蟻的出現主要由食物殘渣和水源所引致。一旦他們找到既有供應的時候，他們就會開始佔據並建立自己的巢穴。如果你的家居出現了曱甴和螞蟻的問題，這些害蟲很可能已經發現了穩定的食物和水源處。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("\n        要有效消滅曱甴和螞蟻的唯一可靠方法，就是將它們由源頭鎖定。威滅"), _c('sup', [_vm._v("®")]), _vm._v(" 速效藥餌含有致命的高效殺蟲成份快倍隆。藥餌被包裝成食物的來源，成份配方混合了碳水化合物，所以對於曱甴和螞蟻而言，絕對是不可抗拒的美味混合物。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("\n        一旦曱甴和螞蟻攝入藥餌，他們就會將其巢穴感染。根據天然習性: 螞蟻會將食物帶回巢穴分享，而曱甴會返回巢穴死亡、繼而被其他曱甴食用同伴屍體，進一步將殺蟲藥傳染到巢穴其他部分，結果就可以達致連環殺滅的功效。\n      ")])]), _vm._v(" "), _c('img', {
    staticClass: "hidden-sm-down",
    attrs: {
      "src": require("../assets/tips-section2.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2 b"
  }, [_c('div', {
    staticClass: "img_wrapper"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tips-section2bb.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("藥餌的殺滅效用")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n        普遍的殺蟲噴霧與威滅® 速效藥餌功效有很大區別。 普遍的殺蟲噴霧只是短期控制害蟲，而威滅"), _c('sup', [_vm._v("®")]), _vm._v(" 速效藥餌的真正目標是長期控制害蟲的入侵。殺蟲噴霧只能殺滅肉眼看見到的害蟲，其如的害蟲會繼續於巢穴存活及繁殖，所以殺蟲噴霧僅能解一時之憂。假若巢穴仍然被置之不理，害蟲入侵的問題只會持續存在，日益惡化。\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4911f660","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PTipsInsecticideGuide.vue
// module id = 238
// module chunks = 0